let refreshPromise: Promise<Response> | null = null

const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_URL || "http://localhost:8001/api"

function buildUrl(input: RequestInfo | URL) {
  if (typeof input === "string" && !input.startsWith("http")) {
    return `${API_BASE_URL}${input}`
  }
  return input
}

export async function customFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const finalUrl = buildUrl(input)

  let res = await fetch(finalUrl, {
    ...init,
    credentials: "include"
  })

  if (res.status !== 401) return res

  // 🔁 prevent multiple refresh calls
  if (!refreshPromise) {
    refreshPromise = fetch(`${API_BASE_URL}/auth/refresh/`, {
      method: "POST",
      credentials: "include"
    }).finally(() => {
      refreshPromise = null
    })
  }

  const refresh = await refreshPromise

  if (!refresh.ok) {
    if (typeof window !== "undefined") {
      window.location.href = "/auth/sign-in"
    }
    throw new Error("Session expired")
  }

  // retry original request
  return fetch(finalUrl, {
    ...init,
    credentials: "include"
  })
}